import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { LOGO, CONTACTS } from "@/lib/config";

export default function Footer() {
  return (
    <footer className="border-t border-red-900/30 bg-black" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <img src={LOGO} alt="TMS Garage" className="h-20 w-auto mb-4" />
          <p className="text-sm text-zinc-500 max-w-xs">Officina meccanica, diagnosi e preparazione. Passione per ogni dettaglio.</p>
        </div>
        <div className="space-y-3 text-sm text-zinc-400">
          <p className="eyebrow mb-4">Contatti</p>
          {CONTACTS.address && <p className="flex gap-2"><MapPin size={16} className="text-red-500" /> {CONTACTS.address}</p>}
          <a href={CONTACTS.phoneHref} className="flex gap-2 hover:text-white" data-testid="footer-phone"><Phone size={16} className="text-red-500" /> {CONTACTS.phone}</a>
          <a href={`mailto:${CONTACTS.email}`} className="flex gap-2 hover:text-white" data-testid="footer-email"><Mail size={16} className="text-red-500" /> {CONTACTS.email}</a>
          {CONTACTS.hours.map(([d, h]) => (
            <p key={d} className="flex gap-2" data-testid="footer-hours"><Clock size={16} className="text-red-500" /> {d}: {h}</p>
          ))}
        </div>
        <div className="text-sm text-zinc-400 flex flex-col gap-2">
          <p className="eyebrow mb-2">Link</p>
          <Link to="/servizi" className="hover:text-white" data-testid="footer-services-link">Servizi & Prodotti</Link>
          <Link to="/galleria" className="hover:text-white" data-testid="footer-gallery-link">Galleria lavori</Link>
          <Link to="/recensisci" className="hover:text-white" data-testid="footer-review-link">Lascia una recensione</Link>
          <Link to="/admin/login" className="hover:text-white" data-testid="footer-admin-link">Area riservata</Link>
        </div>
      </div>
      <div className="border-t border-zinc-900 py-5 text-center text-xs text-zinc-600">© {new Date().getFullYear()} TMS Garage — Tutti i diritti riservati</div>
    </footer>
  );
}
